import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";

const style = {
    bgcolor: "#D00000", 
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxWidth: "90%",
    maxHeight: "90%",
    boxShadow: 24,
    p: 3,
    borderRadius: 2,
};

export default function DescuentosModal({
  open,
  onClose,
  funcionarioSeleccionado,
  descuentosSeleccionados,
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h6">
            DESCUENTOS – {funcionarioSeleccionado?.nombre}
          </Typography>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <DataGrid
          autoHeight
          rows={descuentosSeleccionados.map((d, i) => ({
            id: i,
            ...d,
          }))}
          columns={[
            { field: "tipo", headerName: "Tipo", flex: 1 },
            {
              field: "fecha",
              headerName: "Fecha",
              flex: 1,
              valueFormatter: (params) =>
                new Date(params.value).toLocaleString("es-ES"),
            },
            {
              field: "hora_fin",   // 👈 nueva columna
                headerName: "Hora fin (PERMISO)",
                flex: 1,
                valueFormatter: (params) =>
                params.value ? new Date(params.value).toLocaleString("es-ES") : "",
            },

            { field: "descripcion", headerName: "Detalle", flex: 2 },
            {
                field: "monto",
                headerName: "Monto",
                flex: 1,
                valueFormatter: (params) =>
                    `${params.value.toLocaleString("es-PY")} Gs.`,
            },
        ]}
            sx={{
              borderColor: "white",              // borde general
                "& .MuiDataGrid-columnHeaders": {
                    borderBottom: "1px solid white", // línea bajo los encabezados
                    color: "white",                  // texto encabezado blanco
                },
                "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid white", // líneas entre filas
                    color: "white",                  // texto de las celdas
                },
                    "& .MuiDataGrid-footerContainer": {
                    borderTop: "1px solid white",    // línea arriba del footer
                    color: "white",
                },
            }}

        />

        <Box mt={2} textAlign="right">
          <Typography variant="subtitle1">
            <strong>
              Total Descuentos:{" "}
              {descuentosSeleccionados
                .reduce((sum, d) => sum + d.monto, 0)
                .toLocaleString("es-PY")}{" "}
              Gs.
            </strong>
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}